import React, { useEffect, useRef, useState } from "react";
import { IconButton, Menu, MenuItem, Box, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useContext } from "react";
import { AuthContext } from "../../../Auth/Context";
import useWexClient from "../../../hooks/Clients/wexClient,";
import incidenteMarker from "../../../assets/Markers/incidente-marker.png";
import ajustadorMarker from "../../../assets/Markers/ajustador-marker.png";


export default function MapView({
  technicianLocation,
  incidentLocation,
  isLoggedIn,
  routeCoordinates,
}) {
  const { getStatusAgent } = useWexClient();
  const { payload, logout } = useContext(AuthContext);
  
 

  const mapRef = useRef(null);
  const map = useRef(null);
  const [mapReady, setMapReady] = useState(false);
  const techMarker = useRef(null);
  const destinationMarker = useRef(null);

  const routePolyline = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  // 1. Inicializar el mapa una sola vez
  useEffect(() => {
    console.log("init map -Technician Location:", technicianLocation);
    console.log("init map -Incident Location:", incidentLocation);
    const initMap = () => {
      if (map.current) return; // Si el mapa ya está inicializado, no hacer nada

      map.current = new window.google.maps.Map(mapRef.current, {
        center: { lat: 20.6736, lng: -103.344 }, // Un centro por defecto (Guadalajara)
        zoom: 12,
        disableDefaultUI: true,
        gestureHandling: "greedy",
      });
      setMapReady(true);

      routePolyline.current = new window.google.maps.Polyline({
        map: map.current,
        strokeColor: "#8c31e0ff",
        strokeOpacity: 0.8,
        strokeWeight: 6,
      });

      // Inicializar marcadores sin posición
      destinationMarker.current = new window.google.maps.Marker({
        map: map.current,
        icon: {
          url: incidenteMarker,
          scaledSize: new window.google.maps.Size(78, 78),
        },
      });

      techMarker.current = new window.google.maps.Marker({
        map: map.current,
        icon: {
          url: ajustadorMarker,
          scaledSize: new window.google.maps.Size(78, 78),
        },
      });
    };

    if (!window.google) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY_REPORT}&libraries=places,geometry`;
      script.async = true;
      document.head.appendChild(script);
      script.onload = initMap;
    } else {
      initMap();
    }
  }, []); // El array vacío asegura que esto solo se ejecute una vez

  // 2. Actualizar la ubicación del incidente cuando cambie
  useEffect(() => {
    if (mapReady && destinationMarker.current && incidentLocation) {
      destinationMarker.current.setPosition(incidentLocation);
      map.current.panTo(incidentLocation);
      map.current.setZoom(16);
    }
  }, [incidentLocation, mapReady]);

  // 3. Actualizar la ubicación del técnico cuando cambie
  useEffect(() => {
    if (mapReady && techMarker.current && technicianLocation) {
      techMarker.current.setPosition(technicianLocation);
    }
  }, [technicianLocation, mapReady]);

  // 4. Actualizar la polilínea de la ruta
  useEffect(() => {
    if (mapReady && routePolyline.current) {
      routePolyline.current.setPath(routeCoordinates || []);
    }
  }, [routeCoordinates, mapReady]);

  const updateStatus = async (option) => {
    try {
      const body = {
        agent: payload._id,
        status: option,
        socketID: "",
        consumer: false,
        queue: "",
      };
      await getStatusAgent(body);
    } catch (err) {
      console.log("error", err.message);
    }
  };

  const loggoutSession = async () => {
    await updateStatus("offline");
    logout();
    window.location.href = "/";
  };

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100vh" }}>
      <div ref={mapRef} style={{ width: "100%", height: "100%" }} />
      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          left: 20,
          bgcolor: "white",
          p: 2,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
         <Typography variant="subtitle2">El ajustador esta en camino ... </Typography>
         <Typography variant="subtitle3">NOTA: El ajustador puede tomar rutas alternativas.</Typography>
       
      </Box>

      {isLoggedIn && (
        <>
          <Box
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              bgcolor: "rgba(255,255,255,0.9)",
              borderRadius: "50%",
              boxShadow: 2,
            }}
          >
            <IconButton color="primary" onClick={handleMenuOpen}>
              <AccountCircleIcon sx={{ fontSize: 32 }} />
            </IconButton>
          </Box>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <Box sx={{ px: 2, py: 1 }}>
              <Typography variant="subtitle2" color="#8c31e0ff">
                Mi cuenta
              </Typography>
            </Box>

            <MenuItem onClick={loggoutSession}>Salir</MenuItem>
          </Menu>
        </>
      )}
    </Box>
  );
}
